export class PriceBreakdown {
  operatorPrice: number;
  flightPrice: number;
  commission: number;
  brokerRate: number;

  getOperatorPrice(): number {
    return this.operatorPrice;
  }

  setOperatorPrice(value: number) {
    this.operatorPrice = value;
  }

  getFlightPrice(): number {
    return this.flightPrice;
  }

  setFlightPrice(value: number) {
    this.flightPrice = value;
  }

  getCommission(): number {
    return this.commission;
  }

  setCommission(value: number) {
    this.commission = value;
  }

  getBrokerRate(): number {
    return this.brokerRate;
  }

  setBrokerRate(value: number) {
    this.brokerRate = value;
  }
}
